import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'What is Live Scan fingerprinting?',
    a: 'Live Scan is an inkless, electronic means of capturing fingerprints in a digitized format and then transmitting them to a state or federal agency for background checks.'
  }, {
    q: 'How long does the process take?',
    a: 'The fingerprinting session itself typically takes about 10-15 minutes. Results are usually processed by the state within 24-48 hours.'
  }, {
    q: 'Do I need an appointment?',
    a: 'Yes, all services are by appointment only to ensure we can provide dedicated and efficient service to each client.'
  }];
  return <section className="py-12 lg:py-20 bg-white border-t border-slate-100" aria-labelledby="faq-heading" data-id="element-37">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="text-center mb-16 lg:mb-20" data-id="element-39">
          <h2 id="faq-heading" className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight" data-id="element-40">
            Frequently Asked Questions
          </h2>
          <div className="w-16 h-1.5 bg-[#4AA6CF] mx-auto rounded-full mb-8" aria-hidden="true" data-id="element-41"></div>
        </div>

        <div className="space-y-6" data-id="element-42">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-50 p-8 rounded-2xl border border-slate-200 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300" data-id="element-43">
              <h3 className="text-xl font-extrabold text-slate-900 mb-4 tracking-tight" data-id="element-44">
                {faq.q}
              </h3>
              <p className="text-slate-600 text-base leading-relaxed" data-id="element-45">
                {faq.a}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}